import {Injectable} from '@angular/core';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {UserService} from '../../services/user.service';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {User} from '../../classes/user';

@Injectable({
    providedIn: 'root'
})
export class UserDataSource implements DataSource<User> {

    private userSubject = new BehaviorSubject<User[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    orderBy = 'created_at';
    orderDirection = 'desc';
    searchTerm?: string;
    roleFilter?: string;
    offset: number;
    pageSize: number;
    length: number;
    _paginator: MatPaginator;
    private sourceSubscription: Subscription;

    constructor(private userService: UserService) {

    }

    set sort(matSort: MatSort) {
        const handleSort = (field, direction) => {
            this.orderBy = matSort.active;
            this.orderDirection = matSort.direction;
        };
        handleSort(matSort.active, matSort.direction);
        matSort.sortChange.subscribe(sort => {
            handleSort(sort.active, sort.direction);
            this.loadUsers();
        });
    }

    public set paginator(paginator: MatPaginator) {
        this._paginator = paginator;
        this.offset = paginator.pageIndex * this.pageSize;
        this.pageSize = paginator.pageSize;
        paginator.page.subscribe(page => {
            this.offset = page.pageIndex * this.pageSize;
            this.pageSize = page.pageSize;
            this.loadUsers();
        });
    }

    public set searchString(searchString: string) {
        this.searchTerm = searchString;
        this.loadUsers();
    }

    public set roles(roles: string) {
        this.roleFilter = roles;
        this.loadUsers();
    }

    loadUsers() {
        this.loadingSubject.next(true);

        this.sourceSubscription?.unsubscribe();
        this.sourceSubscription = this.userService.getUsers(this.orderBy, this.orderDirection || 'asc', this.searchTerm, this.offset, this.pageSize, this.roleFilter)
            .subscribe(users => {
                this.userSubject.next(users.data);
                this.length = users.length;
                if (this._paginator) {
                    this._paginator.length = this.length;
                }
            });
    }

    connect(collectionViewer: CollectionViewer): Observable<User[] | ReadonlyArray<User>> {
        return this.userSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.userSubject.complete();
        this.loadingSubject.complete();
        this.sourceSubscription?.unsubscribe();
    }


}
